module.exports = __webpack_public_path__ + "img/Fernsprechen_über_Funk.b8f92fdb.svg";